import React, { useState } from "react";

import Section from "../../ui/components/Section/Section";

import featureFlags from "../../authorization/constants/featureFlags";
import useFeatureFlag from "../../authorization/hooks/useFeatureFlag";
import PublisherDashboard from "../../dashboard/components/Dashboard/PublisherDashboard";

import AlertsWidget from "../components/AlertsWidget/AlertsWidget";
import FavoriteProductionsWidget from "../components/FavoriteProductionsWidget/FavoriteProductionsWidget";
import HomeLanguageDropdown from "../components/HomeLanguageDropdown";
import MyProductionsWidget from "../components/MyProductionsWidget/MyProductionsWidget";
import NotificationsWidget from "../components/NotificationsWidget/NotificationsWidget";
import TodosWidget from "../components/TodosWidget/TodosWidget";
import UpcomingDeliveriesWidget from "../components/UpcomingDeliveriesWidget/UpcomingDeliveriesWidget";
import UpcomingTitlesWidget from "../components/UpcomingTitlesWidget/UpcomingTitlesWidget";
import HomeLayout from "../layouts/HomeLayout/HomeLayout";

const maxWidth = 1800;

export default function HomePublisherView({ organization }) {
	const hasFlatteningFeature = useFeatureFlag(featureFlags.FLATTENING);

	const [language, setLanguage] = useState(null);

	return (
		<>
			{hasFlatteningFeature && (
				<Section maxWidth={maxWidth}>
					<PublisherDashboard organization={organization} />
				</Section>
			)}

			<Section maxWidth={maxWidth}>
				<HomeLanguageDropdown
					organization={organization}
					language={language}
					onChange={(value) => setLanguage(value)}
				/>
				<HomeLayout>
					<HomeLayout.LeftColumn>
						<NotificationsWidget organization={organization} language={language} />

						<TodosWidget organization={organization} language={language} />
					</HomeLayout.LeftColumn>

					<HomeLayout.RightColumn>
						<UpcomingTitlesWidget organization={organization} language={language} />

						<AlertsWidget organization={organization} language={language} />

						<FavoriteProductionsWidget organization={organization} language={language} />

						<MyProductionsWidget organization={organization} language={language} />

						<UpcomingDeliveriesWidget organization={organization} language={language} />
					</HomeLayout.RightColumn>
				</HomeLayout>
			</Section>
		</>
	);
}
